import React from "preact/compat";
import {AllowedElement, CONTROL_BOX_CLASS_PREFIX, START_FRAME, START_STYLE, TargetType} from "./interactable-constants";
import Moveable from "moveable";
import Interactable from "./interactable";
import {ScalableOptions} from "moveable";
import store from "../store";
import util from "../util";
import menuObject from "./menu-object";

const CORNER_DIRECTIONS = ["nw", "ne", "sw", "se"];

export default class MultiInteractable {
  public mov: Moveable;

  public static getInstance(parentElement: AllowedElement, targets: TargetType[]): MultiInteractable {
    return new MultiInteractable(parentElement, targets)
  }

  private constructor(parentElement: AllowedElement, targets: TargetType[]) {
    this.mov = new Moveable(parentElement, {
      target: targets as Array<HTMLElement>,
      draggable: true,
      origin: false,
      hideDefaultLines: false,
      hideChildMoveableDefaultLines: true,
      clickable: true,
      preventClickEventOnDrag: true,
      className: `${CONTROL_BOX_CLASS_PREFIX}group`,
      scalable: {
        edge: [],
        renderDirections: CORNER_DIRECTIONS,
      } as ScalableOptions
    });

    this.mov.on('clickGroup', e => {
      if (e.moveableTarget) {
        if (!store.getState().isShiftPressed) {
          Interactable.selectFromMultiselection(e.moveableTarget);
        }
      }
    })

    this.mov.on('dragGroupStart', e => {
      e.events.forEach(ev => {
        const i = Interactable.of(ev.target);
        i.saveStateOnEvent(ev);
      });
    });

    this.mov.on('dragGroup', e => {
      let stopDrag = false
      e.targets.forEach(tar => {
        const $tar = $(tar);
        if ($tar.hasClass('locked')) {
          stopDrag = true;
        }
      })
      if (!stopDrag) {
        e.events.forEach((ev) => {
          ev.target.style.transform = ev.transform;
          const i = Interactable.of(ev.target);
          i.setTranslateX(ev.translate[0]);
          i.setTranslateY(ev.translate[1]);
          i.updateRect(true);
        });
      }
    });

    this.mov.on('dragGroupEnd', e => {
      e.events.forEach((ev) => {
        Interactable.of(ev.target).onDragEnd(ev, true);
        Interactable.getIfExists(ev.target)?.refreshPosition();
      });

      const events = e.events.map(it => {
        const i = Interactable.of(it.target);
        const oldFrame = JSON.parse(it.datas[START_FRAME]);
        const newFrame = i.cloneCurrentFrame();
        const oldStyle = it.datas[START_STYLE];
        const newStyle = i.cloneCurrentStyle();

        return {
          target: it.target,
          oldFrame,
          newFrame,
          oldStyle,
          newStyle
        }
      });

      Interactable.registerUndo(events, 'Group Drag', true);
    });

    this.mov.on('scaleGroupStart', e => {
      e.events.forEach(ev => {
        const i = Interactable.of(ev.target);
        i.onScaleStart(ev);
        i.saveStateOnEvent(ev);
      });
    });

    this.mov.on('scaleGroup', e => {
      let stopDrag = false
      e.targets.forEach(tar => {
        const $tar = $(tar);
        if ($tar.hasClass('locked')) {
          stopDrag = true;
        }
      })
      if (!stopDrag) {
        e.events.forEach((ev) => {
          ev.target.style.transform = ev.transform;
          const i = Interactable.of(ev.target);
          i.onScale(ev);
          i.updateRect(true);
        });
      }
    });

    this.mov.on('scaleGroupEnd', e => {
      e.targets.forEach((target) => {
        const $el = $(target as AllowedElement);
        const i = Interactable.of(target);
        Interactable.getIfExists(target)?.refreshPosition();
        if (!util.isText($el) && !menuObject.isMenuObject($el)) {
          const curScale = i.getScale();
          const dimensions = util.getActiveDimensions();
          $el.css('width', `${util.pixelToPercent(parseFloat($el.css('width')) * curScale, dimensions.width)}%`);
          $el.css('height', `${util.pixelToPercent(parseFloat($el.css('height')) * curScale, dimensions.height)}%`);
          const transform = JSON.parse($el.attr('data-transform') || '{}');
          const verticalFlip = transform.verticalFlip || false;
          const horizontalFlip = transform.horizontalFlip || false;
          const scale = 1 || 100;
          let rotationDeg = i.getRotation();
          $el.attr('data-transform', JSON.stringify({
            verticalFlip, horizontalFlip, rotationDeg, scale
          }));
          i.groupElementRescale();
        }
        i.groupScaleInteractionEnd();
      });

      const events = e.events.map(it => {
        const i = Interactable.of(it.target);
        const oldFrame = JSON.parse(it.datas[START_FRAME]);
        const newFrame = i.cloneCurrentFrame();
        const oldStyle = it.datas[START_STYLE];
        const newStyle = i.cloneCurrentStyle();

        return {
          target: it.target,
          oldFrame,
          newFrame,
          oldStyle,
          newStyle
        }
      });

      Interactable.registerUndo(events, 'Group Resize', true);
    });
  }
}
